import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";
import { Link } from "react-router-dom";

const COOKIE_CONSENT_KEY = "hireun_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4"
          data-testid="cookie-consent-banner"
        >
          <div className="max-w-4xl mx-auto bg-white border border-border rounded-xl shadow-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Shield className="w-6 h-6 text-primary flex-shrink-0 mt-0.5 sm:mt-0" />
            <div className="flex-1 text-sm text-muted-foreground">
              We use essential cookies to keep you logged in and analytics cookies to improve your experience.
              Read our{" "}
              <Link to="/privacy" className="text-primary underline hover:text-primary/80">
                Privacy Policy
              </Link>{" "}
              for more details.
            </div>
            <div className="flex gap-2 flex-shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={decline}
                data-testid="cookie-decline-btn"
              >
                Decline
              </Button>
              <Button
                size="sm"
                onClick={accept}
                data-testid="cookie-accept-btn"
              >
                Accept
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
